import request from '@/request/index';

/**
 * 系统初始化
 * @param data
 * @constructor
 */
export function DeskInit(data) {
    return request({
        url: '/desk/pub/init',
        method: 'post',
        data
    });
}

/**
 * 获取内容
 * @param data
 * @constructor
 */
export function DeskGetContent(data) {
    return request({
        url: '/desk/pub/getContent',
        method: 'post',
        data
    });
}


/**
 * 获取内容
 * @param data
 * @constructor
 */
export function DeskGetArea(data) {
    return request({
        url: '/desk/pub/getArea',
        method: 'post',
        data
    });
}

/**
 * 获取行业分类
 * @param data
 * @constructor
 */
export function DeskGetCate(data) {
    return request({
        url: '/desk/pub/getCate',
        method: 'post',
        data
    });
}

/**
 * 获取房间背景
 * @param data
 * @constructor
 */
export function DeskGetRootBg(data) {
    return request({
        url: '/desk/pub/getRootBg',
        method: 'post',
        data
    });
}


/**
 * 获取支付类型
 * @constructor
 */
export function DeskGetPayType() {
    return request({
        url: '/desk/pub/getPayType',
        method: 'get'
    });
}

/**
 * 获取省市区地区（级联）
 */
export function DeskGetRegion(data = {}) {
    return request({
        url: '/desk/pub/getRegion',
        method: 'post',
        data
    });
}

/**
 * 获取地图数据（全局缓存）
 */
export function DeskGetMap(data = {}) {
    return request({
        url: '/desk/pub/getMap',
        method: 'post',
        data
    });
}




/**
 * 获取图片列表
 * @constructor
 */
export function DeskGetIcon(data) {
    return request({
        url: '/desk/pub/getIcon',
        method: 'post',
        data : data
    });
}
